/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 * created by cmiller
 */

import Raphael from 'raphael';

export const wrapDynaxisUtil = function(Dyn) {
    let mediator = Dyn.mediator;

    class axisUtil {

        /**
         * Make a settings button for axis view
         * Caller mst position the rect. See updateSettingsRect
         * @param {*} axisView
         */
        static makeSettingsButton( axisView, buttonTypeString, toolTipText, elementId ) {
            let buttonSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
                pathString = Dyn.plotUtil.getSettingsIcon( buttonSize ),
                buttonSet = Dyn.plotUtil.makeSquareButton(
                    axisView.paper, pathString,
                    hoverIn, hoverOut, clickedOnSettings, false, toolTipText, elementId,
                    Dyn.plotUtil.roundRectAxisButtonOptions())
                .data( "type", buttonTypeString )
                .data( "tooltip", toolTipText)
                .hide();
            buttonSet.getSymbolElement().attr({
                fill: Dyn.plotUtil.contextMenuIconUpColor,
                cursor: Dyn.plotUtil.cursorPointer });
            let cover = buttonSet.getCoverElement();
            return buttonSet;

            function hoverIn( event ) {
                cover.attr({ fill: Dyn.plotUtil.axisButtonBgDownColor });
                this.attr( { fill: Dyn.plotUtil.contextMenuIconDownColor } );
                if( this.data("tooltip"))
                    Dyn.toolTip.show( this, event, { x:this.getBBox().x2, y:this.getBBox().y2 } );
            }
            function hoverOut( event ) {
                cover.attr({ fill: Dyn.plotUtil.axisButtonBgUpColor });
                this.attr( { fill: Dyn.plotUtil.contextMenuIconUpColor } );
                if( Dyn.toolTip.isMyElement( this ))
                    Dyn.toolTip.hide();
            }
            function clickedOnSettings( /*event*/ ) {
                mediator.publish( "toolBar:openPlotSettings" );
            }
        }
        static updateSettingsButton( buttonSet ) {
            buttonSet.getSymbolElement().attr({
                fill: Dyn.plotUtil.contextMenuIconUpColor });
            buttonSet.getCoverElement().attr({
                fill: Dyn.plotUtil.axisButtonBgUpColor,
                opacity: Dyn.plotUtil.axisButtonOpacity });
        }
        //static tempDisabledColor = "red";
        static updateAxisButton( buttonSet, isButtonDown=false ) {
            let symbol = buttonSet.getSymbolElement(),
                cover = buttonSet.getCoverElement(),
                isEnabled = cover.data("isEnabled");
            symbol.attr({
                fill: (isButtonDown && isEnabled) ? Dyn.plotUtil.axisButtonDownColor : Dyn.plotUtil.axisButtonUpColor });
            cover.attr({
                fill: (isButtonDown && isEnabled) ? Dyn.plotUtil.axisButtonBgDownColor : Dyn.plotUtil.axisButtonBgUpColor,
                cursor: isEnabled ? Dyn.plotUtil.cursorPointer : Dyn.plotUtil.cursorDisabled,
                opacity: Dyn.plotUtil.axisButtonOpacity });
            cover.node.setAttribute( 'aria-disabled', !isEnabled );
        }

        /**
         * Update position of settings rect
         * @param {*} axisView
         */
        // static updateSettingsRect(axisView) {
        //     if(axisView.allAttributes.count()===0) {
        //         axisView.settingsRect.hide();
        //     } else {
        //         var bufferSize = 10,
        //             bbox = axisView.dropRect.attrs,
        //             x = axisView.isHorizontal? bbox.x + bbox.width : bbox.x + bbox.width / 2,
        //             y = axisView.isHorizontal? bbox.y + bbox.height / 2 : bbox.y;
        //             x += (axisView.axisID==='y2')? bufferSize : -bufferSize;
        //             y += bufferSize;
        //         axisView.settingsRect.transform( "t" + x + "," + y ).toFront();
        //         axisView.settingsRect.show();
        //     }
        // },

        /**
         * Make a close box for the axis view.
         * Caller must position the box; see updateCloseBox().
         * @param axisView
         * @param optionalAttributeIndex {undefined|number} index if multiple attributes.
         * @returns {*}
         */
        static makeCloseBox( axisView, optionalAttributeIndex ) {
            let ariaLabel = axisView.isHorizontal ? Dyn.loc(Dyn.stringFormat(Dyn.plotUtil.promptAxisCloseButtonAriaLabel, 'X-Axis')) : Dyn.loc(Dyn.stringFormat(Dyn.plotUtil.promptAxisCloseButtonAriaLabel, 'Y-Axis')),
                elementId = axisView.isHorizontal ? Dyn.plotUtil.xAxisCloseButtonId : Dyn.plotUtil.yAxisCloseButtonId;

            // make close box and closures
            var closebox = Dyn.plotUtil.makeCloseBox( axisView.paper, buttonHoverIn, buttonHoverOut, clickedOnClosebox , ariaLabel, elementId ),
                cover = closebox.getCoverElement(),
                thisAxis = axisView;

            if( typeof optionalAttributeIndex === 'number' ) {
                // remove only the indicated attribute, if multiple attributes
                closebox.data( "attributeIndex", optionalAttributeIndex );
            }
            return closebox;

            // note: for callbacks this===closebox.getSymbolElement()
            function buttonHoverIn( event ) {
                cover.attr({ fill: Dyn.plotUtil.axisButtonBgDownColor });
                this.attr( { fill: Dyn.plotUtil.axisButtonDownColor, stroke: Dyn.plotUtil.axisButtonDownColor } );
                if( this.data("tooltip"))
                    Dyn.toolTip.show( this, event, { x:this.getBBox().x2, y:this.getBBox().y2 });
            }
            function buttonHoverOut( event ) {
                cover.attr({ fill: Dyn.plotUtil.axisButtonBgUpColor });
                this.attr( { fill: Dyn.plotUtil.axisButtonUpColor, stroke: "none" } );
                if( Dyn.toolTip.isMyElement( this ))
                    Dyn.toolTip.hide();
            }
            function clickedOnClosebox( /*event*/ ) {
                // handler to remove the associated attribute or prompt
                // NOTE: nonAttribute titles like Freq/Percent/Proportion do not have a visible closebox
                let optionalAttributeIndex = this.data( "attributeIndex" );
                this.attr( { fill: Dyn.plotUtil.axisButtonUpColor, stroke: "none" } );
                if( thisAxis.isPromptAxis()) {
                    Dyn.assert( optionalAttributeIndex===0, "expecting that prompt closebox is alone on axis" );
                    thisAxis.setTitle( "" );
                    thisAxis.updateVisuals();
                } else {
                    Dyn.assert(optionalAttributeIndex >= 0, "Invalid attribute index:"+optionalAttributeIndex);
                    Dyn.plotView.removeAttribute( thisAxis, optionalAttributeIndex );
                }
            }
        }

        static updateCloseBox( axisView, closebox, wantVisible, textBBox, attributeIndex ) {
            const textToButtonOffset = 0.5; // to perfectly align button cover rect with textBBox
            var buttonSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
                x, y;

            if ( axisView.isHorizontal ) {
                x = textBBox.x2 + buttonSize/2 + Dyn.plotUtil.axisButtonSpacing;
                y = textBBox.cy + textToButtonOffset;
            } else {
                x = textBBox.cx + textToButtonOffset;	// note: bbox is pre-rotation, so .width influences .y
                y = textBBox.cy - ( textBBox.width / 2 ) - buttonSize/2 - Dyn.plotUtil.axisButtonSpacing;
            }
            closebox.data( "attributeIndex", attributeIndex );
            closebox.transform( "t" + x + "," + y ).toFront();
            closebox.getSymbolElement().attr({
                fill: Dyn.plotUtil.axisButtonUpColor });
            closebox.getCoverElement().attr({
                fill: Dyn.plotUtil.axisButtonBgUpColor,
                opacity: Dyn.plotUtil.axisButtonOpacity });
            Dyn.plotUtil.showOrHideElement( closebox, wantVisible );
            //console.log("updateCloseBox", "t" + x + "," + y, wantVisible?"show":"hide", axisView.isHorizontal? "X":"Y", textBBox.width );
        }

        static makePlusMinusButton( axisView, buttonTypeString, toolTipText, elementId ) {
            "use strict";
            var thisAxis = axisView,
                isPlus = buttonTypeString === "plusButton",
                isMinus = buttonTypeString === "minusButton",
                size = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
                pathString = isPlus ? Dyn.plotUtil.getPlusIcon( size ) : Dyn.plotUtil.getMinusIcon( size ),
                ariaLabel = Dyn.loc( toolTipText );

            Dyn.assert( isPlus || isMinus, "unknown button type: ",buttonTypeString );

            let set = Dyn.plotUtil.makeSquareButton(
                        axisView.paper, pathString,
                        hoverInPlusMinus, hoverOutPlusMinus, clickedOnPlusMinus,
                        false, ariaLabel, elementId,
                        Dyn.plotUtil.roundRectAxisButtonOptions())
                    .data( "type", buttonTypeString )
                    .data( "tooltip", toolTipText)
                    .attr( 'cursor', Dyn.plotUtil.cursorPointer )
                    .hide(),
                cover = set.getCoverElement();
            return set;

            // note: in callbacks this===set.getSymbolElement()
            function hoverInPlusMinus( event ) {
                Dyn.axisUtil.updateAxisButton( set, true ); // show button in down state
                let bbox = this.getCoverElement().getBBox(),
                    tipOptions = (thisAxis.attributeLegend)
                        ? { x:bbox.x, y:bbox.y2, alignRight: true } // legend
                        : { x:bbox.x2, y:bbox.y2 }; // X or Y Axis
                if( this.data("tooltip"))
                    Dyn.toolTip.show( this, event, tipOptions );
            }
            function hoverOutPlusMinus( event ) {
                Dyn.axisUtil.updateAxisButton( set, false ); // show button in up state
                if( Dyn.toolTip.isMyElement( this ))
                    Dyn.toolTip.hide();
            }
            function clickedOnPlusMinus( /*event*/ ) {
                let isEnabled = this.getCoverElement().data("isEnabled");
                if( isEnabled ) {
                    let axisData = {
                        type: this.data( "type" ),
                        actionString: toolTipText /* for now, use tooltip text for undo/redo menu name */
                    };
                    if( thisAxis.attributeLegend ) {
                        axisData.isLegend = true;
                    } else {
                        axisData.isHorizontal = thisAxis.isHorizontal;
                    }
                    mediator.publish( "axis:clickButton", axisData );
                }
                // retain keyboard focus after click, so Enter key can swap back
                Dyn.plotUtil.setAsKeyboardFocus( set.getCoverElement() );
            }
        }

        static makeDragButton( axisView, buttonTypeString, toolTipText, elementId ) {
            "use strict";
            var thisAxis    = axisView,
                isMin       = buttonTypeString === "dragMin",
                isMax       = buttonTypeString === "dragMax",
                isRange     = buttonTypeString === "dragMiddle",
                marginX     = 5, // invisible margin for dragging
                marginY     = marginX,
                dragWidth   = ( axisView.isHorizontal ? axisView.kDragButtonWidth : axisView.kDragButtonHeight),
                dragHeight  = ( axisView.isHorizontal ? axisView.kDragButtonHeight : axisView.kDragButtonWidth),
                pathString,
                ariaLabel;

            Dyn.assert( isMin || isMax || isRange, "unknown button type: ",buttonTypeString );
            if( isRange ) {
                if( axisView.isHorizontal ) {
                    marginX *= 2;
                } else {
                    marginY *= 2;
                }
                pathString = Dyn.plotUtil.getAxisRangeIcon( axisView.isHorizontal );
                ariaLabel = axisView.isHorizontal ? Dyn.loc("Shift X-Axis Range") : Dyn.loc("Shift Y-Axis Range");
            } else if( isMin ) {
                pathString = Dyn.plotUtil.getAxisMinIcon( axisView.isHorizontal );
                ariaLabel = axisView.isHorizontal ? Dyn.loc("Adjust X-Axis Minimum") : Dyn.loc("Adjust Y-Axis Minimum");
            } else {
               pathString = Dyn.plotUtil.getAxisMaxIcon( axisView.isHorizontal );
               ariaLabel =axisView.isHorizontal ? Dyn.loc("Adjust X-Axis Maximum") : Dyn.loc("Adjust Y-Axis Maximum");
            }

            let set = Dyn.plotUtil.makeSquareButton(
                        axisView.paper, pathString,
                        dragHoverIn, dragHoverOut, null,
                        { arrowKeyHandler:arrowKeyHandler },ariaLabel, elementId),
                cover = set.getCoverElement(),
                symbolPath = set.getSymbolElement();
            set.data( "type", buttonTypeString )
                .data( "tooltip", toolTipText)
                .data( "aria-label", Dyn.loc("Swap X and Y Axes new"))
                .hide();
            cover.attr({ x:-marginX, y:-marginY, width:dragWidth+2*marginX, height:dragHeight+2*marginY })
                .drag(
                    moveDraggableNumberline.bind(set),
                    startDraggableNumberline.bind(set),
                    endDraggableNumberline.bind(set)
                );
            symbolPath.attr({ fill: Dyn.plotUtil.kAxisDragFill, stroke: Dyn.plotUtil.kAxisDragStroke });
            return set;

            function arrowKeyHandler( dx, dy, event ) {
                // move one pixel in arrow's direction
                startDraggableNumberline.call( set, event );
                moveDraggableNumberline.call( set, dx, dy, undefined, undefined, event );
                endDraggableNumberline.call( set, event );
            }

            function dragHoverIn( e ) {
                var symbol                   = this;
                e.currentTarget.style.cursor = ( axisView.isHorizontal ) ?
                    Dyn.plotUtil.cursorHorizontalBothSide :
                    Dyn.plotUtil.cursorVerticalBothSide;
                symbol.toFront();
                symbol.attr( { fill: Dyn.plotUtil.axisButtonDownColor, stroke: Dyn.plotUtil.axisButtonDownColor } );
                showToolTip( symbol, e );
            }

            function showToolTip( symbol, e ) {
                if( symbol.data("tooltip")) {
                    var tipX = symbol.attrs.x + (axisView.isHorizontal ? 0 : dragWidth ),
                        tipY = symbol.attrs.y + (axisView.isHorizontal ? - dragHeight : 0 ),
                        alignBottom = (axisView.isHorizontal ? true : false );
                    if( Dyn.toolTip.isMyElement( symbol )) {
                        Dyn.toolTip.update( symbol, e, { x: tipX, y: tipY, alignBottom: alignBottom } );
                    } else {
                        Dyn.toolTip.show( symbol, e, { x: tipX, y: tipY, alignBottom: alignBottom } );
                    }
                }
            }

            function dragHoverOut( e ) {
                var symbol = this;
                e.currentTarget.style.cursor = Dyn.plotUtil.cursorDefault;
                if( ! thisAxis.isInDrag ) {
                    this.attr( { fill: Dyn.plotUtil.kAxisDragFill, stroke: Dyn.plotUtil.kAxisDragStroke } );
                }
                if( Dyn.toolTip.isMyElement( symbol ))
                    Dyn.toolTip.hide();
            }

            function moveDraggableNumberline( dx, dy, x, y, e ) {
                var buttonSet = this,
                    symbol = this.getSymbolElement(),
                    scale = thisAxis.coordMap.scale,
                    isHorizontal = axisView.isHorizontal,
                    dragInDataUnits = (isHorizontal ? dx : dy) * Dyn.mathUtil.invertSafely(scale), // pixels to data units
                    changeMin = (symbol.data( "type" ) !== "dragMax" ), // change since start of drag
                    changeMax = (symbol.data( "type" ) !== "dragMin" ),
                    newMin = symbol.data( "min" ) - (changeMin ? dragInDataUnits : 0 ),
                    newMax = symbol.data( "max" ) - (changeMax ? dragInDataUnits : 0 ),
                    axisData = {
                        isHorizontal: axisView.isHorizontal,
                        axisID: axisView.axisID,
                        type: this.data( "type" ),
                        drag: dragInDataUnits,
                        oldRange: axisView.getNumericAxisRange(),
                        newRange: new Dyn.mathUtil.Range( newMin, newMax ),
                        dx: isHorizontal ? dx : 0, dy: isHorizontal ? 0 : dy };
                //console.log( "moveDraggableNumberline dx="+dx+" dy="+dy+" dragInDataUnits="+dragInDataUnits );

                // move entire button to follow mouse, not just symbol
                if( axisView.isHorizontal ) {
                    buttonSet.transform( "t"+(symbol.data("startX") + dx)+","+symbol.data("startY") );
                } else {
                    buttonSet.transform( "t"+symbol.data("startX")+","+(symbol.data("startY") + dy) );
                }
                showToolTip( symbol, e ); // move tooltip with button

                // tell plot view to update axis and plot together
                mediator.publish( "axis:dragButton", axisData );
            }

            function startDraggableNumberline( /* x, y, e */ ) {
                var buttonSet = this,
                    symbol = this.getSymbolElement();
                thisAxis.isInDrag = true;
                symbol.data( "startX", symbol.data( "x" )); // "x" set by updateDragButtons()
                symbol.data( "startY", symbol.data( "y" )); // "y" set by updateDragButtons()
                Dyn.assert( thisAxis.isNumericalScaleAxis() );
                if( thisAxis.numeric ) {
                    // save starting min and max then get deltas when dragging
                    symbol.data( "min", thisAxis.numeric.axisRange.min );
                    symbol.data( "max", thisAxis.numeric.axisRange.max );
                }
                //console.log( "startDraggableNumberline min="+symbol.data( 'min' )+" max="+symbol.data( 'max' ));
            }

            function endDraggableNumberline( /* e */ ) {
                var buttonSet = this,
                    symbol = this.getSymbolElement(),
                    buttonCover = this.getCoverElement();
                thisAxis.isInDrag = false;
                //thisAxis.layerVisuals(); DON'T do this; let moveDraggableNumberline() call plotView.layerVisuals()
                symbol.removeData( "min" );
                symbol.removeData( "max" );
                symbol.removeData( "startX" );
                symbol.removeData( "startY" );
                symbol.attr( { fill: Dyn.plotUtil.kAxisDragFill, stroke: Dyn.plotUtil.kAxisDragStroke } );
                Dyn.plotUtil.setAsKeyboardFocus( buttonCover );
                thisAxis.updateDragButtons( true ); // animate to reset button position
            }
        }

        /**
         * Make the color key shown next to the attribute name in the axis,
         * indicating the case icon shape, sometimes but not always with a color fill.
         * initially the color rect is an empty path (not visible). See updateColorRect()
         * TODO: rename from "ColorRect" to "AttributeKey" because it is now a closed outline
         * @param axisView
         * @param attributeIndex
         * @returns {*}
         */
        static makeColorRect( axisView, attributeIndex ) {
            "use strict";
            let colorRect = axisView.paper.path("M0,0")
                    .attr({ fill: "none", stroke: "none", 'stroke-width':2 })
                    .data( "attributeIndex", attributeIndex );
            Dyn.plotUtil.disableMouseOverEvents( colorRect );

            return colorRect;
        }

        /** update the attribute key object created by makeColorRect() */
        static updateColorRect( axisView, colorRect, wantVisible, textBBox, attributeIndex, multiAttributeStyle ) {
            "use strict";
            var attributeIndex = colorRect.data( "attributeIndex" ),
                attribute = axisView.allAttributes.attributes[ attributeIndex ],
                isShowingAttributeColor = Boolean(attribute && ! multiAttributeStyle.hasColorAxis ),
                fill = isShowingAttributeColor ? attribute.multiAttrFillColor.colorString : Dyn.plotUtil.axisMultiAttributeFillColor,
                stroke = Dyn.plotUtil.kCaseBorderColor,
                maxHalfSize = (textBBox.height * Dyn.plotUtil.axisMultiAttributeIconSize) / 2,
                halfSize = Math.min( maxHalfSize, Math.max( axisView.kColorSquareHalfSize, multiAttributeStyle.iconStyler.getIconSize()/2 ));

            let cx, cy;
            if ( axisView.isHorizontal ) {
                cx = textBBox.x - axisView.kColorSquareOffset - halfSize;
                cy = textBBox.cy + 1;
            } else {
                cx = textBBox.cx;	// note: bbox is pre-rotation, so .width influences .y
                cy = textBBox.cy + ( textBBox.width / 2 ) + axisView.kColorSquareOffset + 2*halfSize;
            }
            colorRect.data( "attributeIndex", attributeIndex );
            colorRect.data( "iconStyleIndex", multiAttributeStyle.iconStyleIndex );
            if ( wantVisible ){
                let path = Dyn.plotView.plotShaper.iconStyler.calcVariableIconPath(cx, cy, halfSize, multiAttributeStyle.iconStyleIndex);
                colorRect.attr({path: path, fill: fill, stroke: stroke});
                colorRect.show().toFront();
            } else {
                colorRect.attr({path: "M"+cx+","+cy, fill:'none', stroke:'none' });
                colorRect.hide();
            }
        }

        // To set text after converted it into formula using mathJax
        static mathJaxTxtToSVG(text, _callback) {
            // Remove all $ symbol and wrap the returned string with $$
            text = '$$' + text.replace(/\$/g, '').replace(/\s+/g, '\\ ') + '$$';
            // To convert mathJax text to actual formula
            var tmpDiv = document.createElement('div');
            document.body.appendChild(tmpDiv);
            tmpDiv.style.cssText = "visibility: hidden;position: absolute;";
            tmpDiv.innerText = text;

            MathJax.Hub.Queue(['Typeset', MathJax.Hub, tmpDiv], function() {
                const svg = tmpDiv.getElementsByTagName('svg')[0];
                svg.style.pointerEvents = "none";
                _callback(svg);
                tmpDiv.remove();
            });
        }

        /** set or update a text element to either SVG type 'text' or MathJax (type 'g').
         * @param wantMathJaxStr {boolean}
         * @param element {*} - previously created text or g element
         * @param attrs {*} - Rafael attributes to set
         * @param base {*} - base object that holds element
         * @param callback - callback function to set MathJax attributes
         * @returns {*}
         */
        static updateTextOrMathJax( wantMathJaxStr, element, attrs, base, callback  ) {
            Dyn.assert( element );
            Dyn.assert( attrs );
            Dyn.assert( attrs.text );
            let paper = element.paper;
            if( wantMathJaxStr ) {
                // create or update mathJax element
                if( element.type !== 'g' ) {
                    element.remove();
                    element = paper.g().attr( attrs );
                } else {
                    element.attr( attrs );
                }
                // use callback to finish updating mathJax
                // NOTE: callback is called AFTER this function returns, so that calling function
                // has an updated element.
                // It would be ideal rather than passing in a callback, that this function creates a
                // generic callback, that sets the MathJax equivalent parameters to 'attrs'.
                if( base.svgCache?.svg && attrs.text === base.svgCache.text ) {
                    setTimeout(() => callback( base.svgCache.svg ));
                } else {
                    Dyn.axisUtil.mathJaxTxtToSVG( attrs.text, callback );
                }
            } else {
                // create or update text
                if( element.type !== 'text' ) {
                    element.remove();
                    element = paper.text( 0, 0, "" ).attr( attrs );
                } else {
                    element.attr( attrs );
                }
            }

            return element;
        }

        /**
         * To get bounding box value for g element
         * Alternate of Dyn.plotUtil.clipStringToWidth for g element
         **/
        static getBBoxForG(textElem) {
            var bbox = textElem.getBBox(Dyn.plotUtil.textBBoxBeforeTransform);
            // Set bounding box value from x, y, cx, cy, width and height from
            // attributes set through mathjax conversion call back
            if(textElem.node.getAttribute("width")) {
                bbox.width = Number(textElem.node.getAttribute("width"));
                bbox.height = Number(textElem.node.getAttribute("height"));
                bbox.x = Number(textElem.node.getAttribute("x"));
                bbox.y = Number(textElem.node.getAttribute("y"));
                bbox.cx = Number(textElem.node.getAttribute("cx"));
                bbox.cy = Number(textElem.node.getAttribute("cy"));
                bbox.x2 = bbox.x + bbox.width;
                bbox.y2 = bbox.y + bbox.height;
            }
            return bbox;
        }

        /**
         * Determine if the attribute has changed, and whether we need to strip the NACoord "a" coordinates.
         * This causes the objects to stay in the same relative view position (via normalized coordinates)
         * even when the axis has completely different attribute coordinates.
         * @param oldAttributeID
         * @param axisView -- axis view, may be null (e.g. to handle optional Y2 axis)
         * @returns {{}}
         */
        static isNewAttributeCoord( oldAttributeID, axisView, isNewlyRestoredData ) {
            "use strict";
            var result = {};

            result.isNumericAxis = axisView && axisView.isNumericalScaleAxis();
            result.newAttributeID = result.isNumericAxis ? axisView.getFormattingAttribute().id : "";
            result.needToStripCoords = ( oldAttributeID !== result.newAttributeID || !(result.newAttributeID) );
            if( isNewlyRestoredData && result.isNumericAxis) {
                //console.log( "Dyn.axisUtil.isNewAttributeCoord() is preserving exact axis values for attribute "+result.newAttributeID );
                result.needToStripCoords = false;
            }
            return result;
        }

        /**
         * How much do we adjust the edges of this axis, to match the expansion of the other axis, so the corners meet?
         * Note the results are 0+ if a change is needed, direction of change varies according to context.
         * @returns {*} number of pixels drop zone of thisAxis should change on left, right, top, bottom
         */
        static getDropAreaThicknessChange( thisAxis, otherAxis, otherAxis2, legend ) {
            function deltaMax( d ) {
                return Math.max( d, Dyn.plotUtil.dropExpandMin) - d; // distance, adjusted to be no less than dropExpandMin
            }
            function dropRectLeft( axis ) { return axis.dropRect.attrs.x; }
            function dropRectRight( axis ) { return axis.dropRect.attrs.x + axis.dropRect.attrs.width; }
            function dropRectBottom( axis ) { return axis.dropRect.attrs.y + axis.dropRect.attrs.height; }
            function dropRectWidth( axis ) { return axis.dropRect.attrs.width; }

            var deltaThickness = { left:0, right:0, top:0, bottom:0 };
            if( thisAxis.axisID==='x' ) {
                deltaThickness.left = deltaMax( dropRectLeft( thisAxis ) - dropRectLeft( otherAxis )); // inset of x-axis on left because of y-axis
                if( otherAxis2 ) {
                    deltaThickness.right += deltaMax(dropRectWidth( otherAxis2 ))+deltaMax(dropRectWidth(legend)); // inset of x-axis on right if Y2 axis and/or legend expands
                } else if( legend ) {
                    deltaThickness.right += deltaMax( legend.bounds.right() - thisAxis.bounds.right()); // inset of x-axis on right if legend expands
                }
            } else if( thisAxis.axisID==='y' ) {
                deltaThickness.bottom = deltaMax( dropRectBottom( otherAxis ) - dropRectBottom( thisAxis )); // inset of y-axis on bottom
            } else if( thisAxis.axisID==='y2' ) {
                deltaThickness.bottom = deltaMax( dropRectBottom( otherAxis ) - dropRectBottom( thisAxis )); // inset of y-axis on bottom
                deltaThickness.right = deltaMax(dropRectWidth(legend)); // shift left because of expanding legend?
            }
            // note: thisAxis.axisID==='right' possible but not needed, see RightMargin.hightlightDropAreas()
            console.log("getDropAreaThicknessChange", thisAxis.axisID, deltaThickness );
            return deltaThickness;
        }

        static shiftTitle( title, bbox, dx, dy, isRotatedText ) {
            if(( dx !== 0 ) || (dy !== 0)) {
                if( isRotatedText ) { // don't change transform, just shift pre-rotation
                    title.attr( { x: bbox.cx, y: bbox.cy + dx } );
                } else { // normal text shift
                    title.attr( { x: bbox.cx + dx, y: bbox.cy + dy } );
                }
            }
        }
        static shiftButton( button, dx, dy ) {
            let cb = button.getBBox(),
                cbcx = (cb.x + cb.x2)/2,
                cbcy = (cb.y + cb.y2)/2;
            button.transform( "t" + (cbcx+dx) + "," + (cbcy+dy) ).toFront();
        }
        static shiftPath( pathElement, dx, dy ) {
            let path = pathElement.attr( "path" );
            path = Raphael.transformPath( path, "T"+dx+","+dy );
            pathElement.attr( "path", path );
        }

    }   // end class axisUtil
    Dyn.axisUtil = axisUtil;

    class NACoord {
        /**
         * Construct an { n, a } coordinate object,
         * That tracks some point in normalized coordinates [0-1] and attribute coordinates (e.g. inches).
         * Used to track objects on the axis by attribute coordinates (a) when possible,
         * but otherwise by normalized coordinates, so object is stable even when attributes are swapped or removed.
         * @param normalizedCoord
         * @param attributeCoord
         * @constructor
         */
        constructor( normalizedCoord, attributeCoord ) {
            this.n = normalizedCoord || 0;
            if( Dyn.mathUtil.isFinite(attributeCoord) ){
                this.a = attributeCoord;
            }
        }

        /**
         * remove our attribute coordinate,
         * used when the attribute is removed or replaced by a new attribute on the axis.
         */
        stripAttributeCoord() {
            delete this.a;
        }

        hasAttributeCoord() {
            return Dyn.mathUtil.isFinite( this.a );
        }

        getViewCoord( axisView ) {
            let viewCoord;
            if( Dyn.mathUtil.isFinite( this.a )) {
                // use attribute coords if they exist
                viewCoord = axisView.coordMap.transform( this.a );
            }
            else {
                // else use normalized coords
                Dyn.assert( Dyn.mathUtil.isFinite( this.n ), "undefined normalized coordinate" );
                viewCoord = axisView.coordMap.fractionToDest( this.n );
                if( axisView.isNumericalScaleAxis() ) {
                    // also save as attribute coordinates, so future axis changes keep the object in the same attribute position
                    this.a = axisView.coordMap.fractionToSource( this.n );
                }
            }
            return viewCoord;
        }

        /**
         * Update our normalized coordinate value from the view coordinate of the given axis.
         * If the axis is a numberline, we can also update the attribute coordinate.
         * optionally, snap the attribute coordinate to the nearest tickmark on the axis.
         */
        updateFromViewCoord( viewCoord, axisView, wantSnapToTickmarks, snapDistanceInPixels ) {
            this.n = axisView.coordMap.destToFraction( viewCoord );
            if( axisView.isNumericalScaleAxis()) {
                // numeric axis: update the axis coordinate (.a)
                this.a = axisView.coordMap.inverseTransform( viewCoord );
                if( wantSnapToTickmarks ) {
                    let newAxisCoord = axisView.snapIfCloseToTickmark( this.a, snapDistanceInPixels );
                    if( newAxisCoord !== this.a ) {
                        this.a = newAxisCoord;
                        this.n = axisView.coordMap.sourceToFraction( newAxisCoord );
                    }
                }
            } else if( wantSnapToTickmarks && Dyn.plotUtil.isDrawOnly()) {
                // draw-only mode: snap .n to grid lines if present and nearby
                this.n = axisView.snapIfCloseToTickmark( this.n, snapDistanceInPixels );
            }
        }

        /**
         * save the normalized coordinate, for positioning in any plot type (e.g. 0.5 = middle of X or Y)
         * plus the attribute coordinate if any, for more accurate positioning (e.g.length=12.3)
         * @return {{n:number}|{n:number,a:number}}
         */
        save() {
            let savedData = { n: this.n };
            if( Dyn.mathUtil.isFinite( this.a )) {
                savedData.a = this.a; // only save if defined
            }
            return savedData;
        }

        static restore( savedData ) {
            return new Dyn.axisUtil.NACoord( savedData.n, savedData.a );
        }
    }   // end class NACoord
    Dyn.axisUtil.NACoord = NACoord;

    /**
     *  Utility class for dragging categories in the X, Y, or Legend views,
     *  so that categories order be re-arranged.  This is independent of ascending or descending
     *  category order which can be flipped. */
    class DragCategoryUtil {
        constructor( view, cat0Coord, catOffset, numCategories, attribute ) {
            // data shared by categories being dragged, save as element.data('dragInfo',new DragCategoryUtil(...))
            this.view = view; // class AxisView, Y2AxisView, or RightMarginView
            this.isOnX = this.view.isHorizontal;
            this.cat0Coord = cat0Coord; // view coordinate position of first category in view
            this.catOffset = catOffset; // view distance between categories
            this.numCategories = numCategories;
            this.animationTimeMS = Dyn.plotUtil.quickAnimationTimeMs/2;
            this.animationEasing = Dyn.plotUtil.quickAnimationEasing
            this.isDraggable = Boolean( numCategories >= 2 && // must have 2+ categories
                attribute && ! (attribute.hasNumericIntervals()  // and not temporary intervals
                    || attribute.hasNumericIntervalsDataType())); // and not data type Categorical:NumericIntervals
            this.attributeID = attribute?.id;
            // NOTE: coordinates for category positions above (cat0Coord, catOffset) are for the text element
            // of the category.  For the symbol (dot or color square) next to the category, use this offset
            // from the paired text element:
            this.symbolOffset = 0;
        }

        setSymbolOffset( offset ) {
            this.symbolOffset = offset;
        }

        /**
         * Get the name of the coordinate to modify while dragging categories.
         * @param element -- element to drag or get coordinate from
         * @returns {string} -- 'x', 'cx', etc for element.attr( 'x', coordinate );
         */
        coordName( element ) {
            //let isRotated90 = /r/.test( element.attr('transform')),
            //    useX = isRotated90 ? (!this.isOnX) : this.isOnX;
            if( element.type==='circle')
                return this.isOnX ? 'cx' : 'cy'; // change cx/cy when dragging a circle element
            else
                return this.isOnX ? 'x' : 'y';  // change x/y when dragging a text or rect element
        }

        isClickNotDrag( oldCoord, newCoord ) {
            return( Math.abs( newCoord-oldCoord ) < 1 );
        }

        /** modify position of drag position to not go outside bounds of category area */
        getLimitedDragPosition( coord  ) {
            let minMax = (new Dyn.mathUtil.Range(
                this.cat0Coord - (this.catOffset * 0.5), // to 1/2 line above 0th category
                this.cat0Coord + (this.catOffset * (this.numCategories - 0.5))) // and 1/2 line below last category
            ).normalize(); // coordinate may be descending if categories in reverse order (e.g. Categorical:numericIntervals on Y)
            return Dyn.mathUtil.clipToMinMax( minMax.min, minMax.max, coord );
        }

        /**
         * Calculate the new category index, given the original position plus distance dragged in view coordinates.
         * We clip the index to not go beyond valid category indices [0-(numCategories-1)] */
        getCategoryIndexFromDelta( oldIndex, deltaCoord ) {
            let deltaIndex = Math.round( deltaCoord / this.catOffset );
            return Dyn.mathUtil.clipToIntegerRange( oldIndex + deltaIndex, 0, this.numCategories );
        }

        /**
         * Given a category index, modify that index to skip over the category index where the
         * dragged category will go. Used to reposition other (non-dragged) categories out of the way.
         * @param categoryIndex -- index of category to (re-)position (NOT the dragged category)
         * @param oldDraggedIndex -- original index of dragged category
         * @param newDraggedIndex -- new position of dragged category
         */
        getCategoryIndexWithSkipping( categoryIndex, oldDraggedIndex, newDraggedIndex ) {
            let minMovedIndex = Math.min( oldDraggedIndex, newDraggedIndex ),
                maxMovedIndex = Math.max( oldDraggedIndex, newDraggedIndex ),
                offset = ((newDraggedIndex-oldDraggedIndex) > 0) ? -1 : 1,
                newIndex1 = newDraggedIndex,
                newIndex2 = categoryIndex + ((categoryIndex < minMovedIndex || categoryIndex > maxMovedIndex ) ? 0 : offset);
            //console.log( "getCategoryIndexWithSkipping", categoryIndex, minMovedIndex, maxMovedIndex, offset );
            return (categoryIndex===oldDraggedIndex) ? newIndex1 : newIndex2;
        }
    }
    Dyn.DragCategoryUtil = DragCategoryUtil;

    /** Utility class to determine the size and rotation of text labels on an axis */
    class AxisLabelUtil {
        constructor( axisIsHorizontal ) {
            this.isHorizontal = axisIsHorizontal; // axis is horizontal or vertical?
            this.noRotateBBox = new Dyn.mathUtil.Rect(0,0,0,0); // text bounding box of the longest label, pre-rotation
            this.wantRotation = false; // true if text fits better if rotated (to vertical)
            this.indexOfLongestLabel = -1;
        }

        /**
         * Get the rotation and maximum length of the labels, after fitting them in the axis.
         * @param labelsArray
         * @param attribute
         * @param paper
         * @param axisWidth
         * @param labelFontSize
         * @param spaceBetweenLabels
         * @returns {*} - thickness of rotatel label in view coords, on cross-axis.
         */
        getLabelThicknessAndRotation( labelsArray, attribute, paper, axisWidth, labelFontSize, spaceBetweenLabels ) {
            this._getLabelMaxBBox( labelsArray, attribute, paper, labelFontSize);
            this._getLabelRotation( labelsArray.length, axisWidth, spaceBetweenLabels );
            return this.getLabelThickness();
        }

        // get height and width of the longest label (category or tick mark string)
        // also save the index of the longest label
        _getLabelMaxBBox( labelsArray, attribute, paper, labelFontSize ) {
            let textBBox = new Dyn.mathUtil.Rect();
            labelsArray.forEach( ( value, index ) => {
                var text       = attribute.categoryValueToString( value ),
                    textBounds = Dyn.plotUtil.getTextBBox( paper, text, labelFontSize )
                if( textBBox.height < textBounds.height ) {
                    textBBox.height = textBounds.height;
                }
                if( textBBox.width < textBounds.width ) {
                    textBBox.width = textBounds.width;
                    this.indexOfLongestLabel = index; // save for axis display
                }
            });
            this.noRotateBBox = textBBox;
        }

        // get the space in pixels available for each label along axis
        // (e.g. 100 pixels axis / 5 ticks = 20 pixels)
        _getLabelRotation( numLabels, axisWidth, spaceBetweenLabels ) {
            let spacePerLabel = axisWidth * Dyn.mathUtil.invertSafely( numLabels ),
                widestLabelWidth = this.noRotateBBox.width + spaceBetweenLabels;

            if( this.isHorizontal ) {
                this.wantRotation = ( widestLabelWidth >= spacePerLabel ); // X-axis: rotate only if too wide for horizontal
            } else {
                this.wantRotation = ( widestLabelWidth < spacePerLabel );  // Y-axis: rotate only if enough space to be rotated
            }
        }

        /**
         * Label Thickness is size to use in cross-axis, after label rotation.
         * e.g. on Y axis, horizontal space to reserve for longest label
         * or on X axis, vertical space to reserve for longest label.
         * @returns {*}
         */
        getLabelThickness() {
            return this.noRotateBBox.widthOrHeight( this.isHorizontal === this.wantRotation );
        }

        /**
         * NOTE: if labels will overlap, we carefully hide every X number of labels, so that they don't.
         * AND we make sure to show the longest label, otherwise our axis spacing is too large (issue #327)
         * Use isVisibleLabel() to test each label for visibility
         */
        showEveryXLabelsStart( axisScale ) {
            Dyn.assert( this.noRotateBBox );
            let minLabelSpacing = this.noRotateBBox.height; // minimum space for labels is text height
            this.showEveryXLabels = Math.max( 1, Dyn.mathUtil.ceiling( minLabelSpacing * Dyn.mathUtil.invertSafely( axisScale ) ) ); // 1+
            this.labelsArePerpendicularToAxis = (this.isHorizontal === this.wantRotation);
            this.indexOfFirstVisibleLabel = (this.labelsArePerpendicularToAxis ? (this.indexOfLongestLabel % this.showEveryXLabels) : 0); // 0+
            return this.indexOfFirstVisibleLabel;
        }

        /** is this a visible label, after calling showEveryXLabelsStart()? */
        isVisibleLabel( labelIndex ) {
            let isVisibleLabel =( (labelIndex % this.showEveryXLabels ) === this.indexOfFirstVisibleLabel );
            let isLongestLabel =( this.labelsArePerpendicularToAxis && (labelIndex === this.indexOfLongestLabel));
            Dyn.assert( isLongestLabel ? isVisibleLabel : true, "ERROR hiding longest label" );
            return isVisibleLabel;
        }

        isHidingSomeLabels() {
            return this.showEveryXLabels > 1;
        }

    } // class AxisLabelUtil
    Dyn.AxisLabelUtil = AxisLabelUtil;

}; // end wrapDynaxisUtil
